export const OPERATIONAL = 'operational';
export const ERROR = 'error';
export const USER_ERROR = 'user error';
export const CONNECTED = 'connected';
export const NOT_CONNECTED = 'not connected';
export const UNKNOWN = 'unknown';
export const NO_PING = 'no ping';
export const OUT_OF_STOCK = 'out_of_stock';
